<template>
	<JBox class="s-pt-5">
		<JFlex class="s-flex-col">
			<!-- Draggable cards -->
			<!-- <JDraggable
				:list="selectedProperty === 'customCss' ? [] : themeConfig[`${selectedProperty}`]"
				v-bind="dragOptions"
				@end="$emit('updateTheme', themeConfig)"
				:disabled="this.selectedProperty === 'customCss'"
				:force-fallback="true"
			> -->
			<AppThemeSlotCard
				class="s-my-3"
				v-for="(property, i) in themeConfig[`${selectedProperty}`]"
				:key="`${selectedProperty}: ${property.name} ${i}`"
				:selectedProperty="`${selectedProperty}`"
				:property="property"
				@propertyChanged="updateTheme"
			/>
			<!-- </JDraggable> -->
		</JFlex>
	</JBox>
</template>
<script>
import AppThemeSlotCard from "./AppThemeSlotCard"
export default {
	components: { AppThemeSlotCard },

	data() {
		return {
			themeConfig: {},
			// TODO: Drag options not working, need better dragging effects
			dragOptions: {
				animation: 200,
				group: "description",
				disabled: false,
				ghostClass: "s-opacity-0"
			}
		}
	},

	props: {
		selectedProperty: {
			type: String,
			default: "colors"
		},

		themeConfigString: {
			type: String,
			default: ""
		}
	},

	// Watcher is needed as fetchConfig in `AppTheme.vue` is an async func.
	watch: {
		themeConfigString() {
			const themeConfigObject = JSON.parse(this.themeConfigString)
			this.themeConfig = themeConfigObject
		}
	},

	methods: {
		updateTheme(val) {
			let newThemeConfig = this.themeConfig

			if (this.selectedProperty === "customCss") {
				newThemeConfig.customCss.cssString = val
			} else {
				const newProperty = this.themeConfig[this.selectedProperty].map(property => {
					return property.id === val.id ? val : property
				})
				newThemeConfig[this.selectedProperty] = newProperty
			}
			this.$emit("updateTheme", newThemeConfig)
		}
	}
}
</script>
